export interface LoginDto {
  password: string
  email: string
  rememberMe: boolean
}
export interface ResetDto {
  email: string
  password: string
  password_confirmation: string
  token: string
}

export const useAuthService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api/auth`

  return {
    signInUser(p: LoginDto) {
      return fetchJson<FetchResult<void>, LoginDto>(
        'POST', `${BASE_URL}/login`, p,
      )
    },
    logout() {
      return fetchJson<FetchResult<void>>(
        'POST', `${BASE_URL}/logout`,
      )
    },
    resetPassword(dto: { email: string }) {
      return fetchJson<FetchResult<void>, typeof dto>(
        'POST', `${BASE_URL}/forgot-password`, dto,
      )
    },

    askForResetPassword(dto: ResetDto) {
      return fetchJson<FetchResult<void>, typeof dto>(
        'POST', `${BASE_URL}/reset-password`, dto,
      )
    },
  }
}
